import { PaymentCandidatesResponse } from '@api/admin/adminGeneratedApi';
import { Typography } from '@mui/material';
import { PaymentCandidateProcessStatusColors, PaymentCandidateProcessStatusName } from '@area/payments/defaultValues';
import { PaymentCandidateProcessStatus, PaymentCandidateProcessStatusProcessing } from '@area/payments/types';

const getStatus = ({
  errorDate,
  rejectedDate,
  approvedDate,
  deletedAt,
}: PaymentCandidatesResponse): PaymentCandidateProcessStatus | PaymentCandidateProcessStatusProcessing => {
  if (errorDate) {
    return PaymentCandidateProcessStatus.error;
  } else if (rejectedDate) {
    return PaymentCandidateProcessStatus.rejected;
  } else if (approvedDate) {
    return PaymentCandidateProcessStatus.approved;
  } else if (deletedAt) {
    return PaymentCandidateProcessStatus.deleted;
  } else {
    return PaymentCandidateProcessStatusProcessing.processing;
  }
};

export const Status = (candidate: PaymentCandidatesResponse) => {
  const status = getStatus(candidate);

  return (
    <Typography color={PaymentCandidateProcessStatusColors[status]}>
      {PaymentCandidateProcessStatusName[status]}
    </Typography>
  );
};
